(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["iceblade-product-page"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var nav=document.getElementById('vq-nav');
    if(nav){window.addEventListener('scroll',function(){nav.style.background=window.scrollY>60?'rgba(10,22,40,0.97)':'#0a1628';nav.style.borderBottomColor=window.scrollY>60?'rgba(90,180,247,0.15)':'rgba(90,180,247,0.08)';});}
    var section=document.querySelector('[data-iceblade-product]');
    if(!section)return;
    var slides=Array.from(section.querySelectorAll('.ib-slide'));
    var thumbs=Array.from(section.querySelectorAll('.iceblade-thumb'));
    var counter=section.querySelector('.ib-slide-current');
    var current=0;
    function goTo(index,dir){
      if(slides.length<=1)return;
      if(index<0)index=slides.length-1;
      if(index>=slides.length)index=0;
      if(index===current)return;
      slides[current].classList.remove('is-active','is-dir-prev');
      slides[index].classList.remove('is-dir-prev');
      if(dir==='prev')slides[index].classList.add('is-dir-prev');
      slides[index].classList.add('is-active');
      thumbs.forEach(function(t){t.classList.remove('is-active');});
      if(thumbs[index]){thumbs[index].classList.add('is-active');thumbs[index].scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});}
      if(counter)counter.textContent=index+1;
      current=index;
    }
    var prev=section.querySelector('.ib-arrow--prev');
    var next=section.querySelector('.ib-arrow--next');
    if(prev)prev.addEventListener('click',function(){goTo(current-1,'prev');});
    if(next)next.addEventListener('click',function(){goTo(current+1,'next');});
    thumbs.forEach(function(thumb,i){thumb.addEventListener('click',function(){goTo(i,i>current?'next':'prev');});});
    var slideshow=section.querySelector('.iceblade-slideshow');
    var touchStartX=0;
    if(slideshow){
      slideshow.addEventListener('touchstart',function(e){touchStartX=e.touches[0].clientX;},{passive:true});
      slideshow.addEventListener('touchend',function(e){var d=touchStartX-e.changedTouches[0].clientX;if(Math.abs(d)>40)goTo(d>0?current+1:current-1,d>0?'next':'prev');});
    }
    document.addEventListener('keydown',function(e){if(e.key==='ArrowLeft')goTo(current-1,'prev');if(e.key==='ArrowRight')goTo(current+1,'next');});
    section.addEventListener('change',function(event){
      if(!event.target.matches('[name="iceblade_bundle"]'))return;
      var radio=event.target;
      section.querySelectorAll('[data-bundle-label]').forEach(function(l){l.classList.remove('is-selected');});
      radio.closest('[data-bundle-label]').classList.add('is-selected');
      section.querySelector('[data-iceblade-quantity]').value=radio.dataset.quantity;
      section.querySelector('[data-iceblade-button-price]').textContent=radio.dataset.price;
      var compareEl=section.querySelector('[data-iceblade-button-compare]');
      if(compareEl)compareEl.textContent=radio.dataset.originalPrice||'';
    });
    var srEls=document.querySelectorAll('.vq-sr');
    var srIO=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('vq-visible');srIO.unobserve(e.target);}});},{threshold:0.12});
    srEls.forEach(function(el){srIO.observe(el);});
    var counters=document.querySelectorAll('[data-count]');
    var cntIO=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          var el=e.target;var target=parseInt(el.getAttribute('data-count'));
          var start=0;var step=target/1600*16;
          var timer=setInterval(function(){start+=step;if(start>=target){start=target;clearInterval(timer);}el.textContent=Math.floor(start);},16);
          cntIO.unobserve(el);
        }
      });
    },{threshold:0.5});
    counters.forEach(function(c){cntIO.observe(c);});
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
